import styled from "@emotion/styled";

import { fontRoboto, theme } from "shared/lib/styles";

import { Loading } from "scmp-app/components/common/loading";

export const StyledLoading = styled(Loading)`
  margin-block: 40px;
  margin-inline: 0;
`;

export const Container = styled.section``;

export const Title = styled.div`
  padding-block: 12px;
  padding-inline: 0;

  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 20px;
  text-align: center;

  ${theme.breakpoints.up("tablet")} {
    padding-block: 14px;
    padding-inline: 0;

    font-size: 20px;
    font-family: ${fontRoboto};
    line-height: 24px;
  }
`;
